// extracted by mini-css-extract-plugin
module.exports = {"list":"_025a50318d--list--2d8UD","list-element":"_025a50318d--list-element--2-qFY","list-element--active":"_025a50318d--list-element--active--1gFdF"};